function pageHeader() {

  var directive = {
    template: require('./bmo.pageHeader.html'),
    controller: PageHeaderController,
    controllerAs: 'pageHeaderController'
  };

  function PageHeaderController($scope, $window, coreService) {
    $scope.baseUri = 'https://www.bmospenddynamics.com';
    $scope.selectedLanguage = {
      code: '',
      productLanguageId: ''
    };
    $scope.openHelp = openHelp;

    var model = coreService.getIdentityModel();
    if (model && model.custom) {
      $scope.baseUri = model.custom.api_base;
      $scope.selectedLanguage.productLanguageId = model.custom.language;
      $scope.selectedLanguage.code = model.custom.ui_locales;
    }
    else {
      $scope.selectedLanguage.code = model.ui_locales;
    }

    function openHelp() {
      var width = 800,
        height = 300,
        left = (screen.availWidth - width) / 2,
        top = (screen.availHeight - height - 32) / 2;
      var windowOptions = 'width=' + width + ',height=' + height + ',resizable=1,scrollbars=1,left=' + left + ',top=' + top + ',status=0';
      var windowHold = $window.open($scope.baseUri + '/Information/ContactUs?language_id=' + $scope.selectedLanguage.productLanguageId, 'BMO_ContactUs', windowOptions);
      windowHold.focus();
    }
  }
  return directive;
}

export default pageHeader;


// WEBPACK FOOTER //
// ./src/login/header/bmo.pageHeader.js